import React from 'react';

interface MessageBubbleProps {
  content: string;
  timestamp?: string;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ content, timestamp }) => {
  return (
    <div className="flex justify-end mb-2">
      <div className="bg-[#DCF8C6] rounded-lg px-3 py-2 max-w-[85%] shadow-sm">
        <p className="text-sm text-gray-800 whitespace-pre-wrap break-words">
          {content || '(mensaje vacío)'}
        </p>
        <div className="flex justify-end items-center gap-1 mt-1">
          <span className="text-[10px] text-gray-600">
            {timestamp || new Date().toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      </div>
    </div>
  );
};
